<template>
  <div class="customer-schedule-change-filling rj-page-card">
    <ExpectedDeliveryDateChangeForm
      ref="expectedDeliveryDateChangeForm"
      :is-detail="isDetail"
      :is-apply="isApply"
      :status="status"
      :application-id="applicationId"
      @changeCeddType="handleChangeCeddType"
    />
    <FileUpload ref="fileList" :change-type="changeType" :is-detail="isDetail" :is-apply="isApply" />
  </div>
</template>
<script>
import ExpectedDeliveryDateChangeForm from './components/ExpectedDeliveryDateChangeForm.vue';
import FileUpload from './components/FileUpload.vue';
import { deepCopy } from '@/libs/util';

export default {
  name: 'CustomerScheduleChangeFilling',
  emits: ['changeCeddType'],
  components: { FileUpload, ExpectedDeliveryDateChangeForm },
  props: {
    // 是否是详情
    isDetail: {
      type: Boolean,
      default: false
    },
    // 是否是申请
    isApply: {
      type: Boolean,
      default: false
    },
    // 变更类型
    changeType: {
      type: String,
      default: ''
    },
    // 申请单单号
    applicationId: {
      type: String,
      default: ''
    },
    status: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    // 设置默认表单数据
    setDefaultFormData (data) {
      const { base, form, files } = deepCopy(data);
      this.$refs.expectedDeliveryDateChangeForm.setDefaultFormData(base || {}, form || {});
      this.$refs.fileList.setDefaultFormData(files || []);
    },

    // 获取表单数据
    getFormData () {
      const form = this.$refs.expectedDeliveryDateChangeForm.getFormData();
      const files = this.$refs.fileList.getFormData();
      if (!form) return false;
      if (!files) return false;
      return deepCopy({ form, files });
    },

    handleChangeCeddType (val) {
      this.$emit('changeCeddType', val);
    }
  }
};
</script>

<style scoped lang="scss">
// :deep(.el-table--mini) {
//   font-size: 14px;
//   .el-table__cell {
//     padding: unset;
//   }
// }

// :deep(.el-table__header) {
//   .el-table__cell {
//     height: 52px !important;
//   }
// }

// :deep(.el-table__row) {
//   .el-table__cell {
//     height: 48px !important;
//   }
// }
:deep(.el-form-item__label) {
  font-size: 14px !important;
}
:deep(.el-descriptions-item__cell) {
  font-size: 14px;
  padding: 10px 0;
}
</style>
